import { api } from "../../utils/api";

export async function postBradescoPaidQuery(data) {
  try {
    const response = await api.post("/homologation/bradesco_paid_query", data);
    return response.data;
  } catch (error) {
    console.error("Error syncing with Bradesco:", error);
    throw error;
  }
}

